import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { ChatbotComponent } from './app/chatbot/chatbot.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/services/auth.interceptor';
import { routes } from './app/app.routes';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { importProvidersFrom } from '@angular/core';
import { loadBootState } from './app/boot/boot-state';
import { getNavigationTimingSnapshot, markLoad } from './app/boot/load-timing';
import { debugLog } from './app/services/debug-log.service';

// Capture console output, uncaught errors and rejections as early as possible so a
// signed RELEASE build (no chrome://inspect) can still surface errors on screen.
debugLog.install();


// Sentry.init({
//   dsn: "https://3448a75fc85dc26d60878fc98c63685e@o469969.ingest.us.sentry.io/4508445875306496",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/192.168.1.28/, /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });


/*bootstrapApplication(ChatbotComponent, {
  providers: [provideRouter(routes), provideHttpClient(),{ provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,],
}).catch((err) => console.error(err));*/

loadBootState();
markLoad('boot_state_loaded');

bootstrapApplication(AppComponent, {
  providers: [
    appConfig.providers,
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    importProvidersFrom(),
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
  ],
})
  .then(() => {
    markLoad('angular_bootstrap_complete');
    const navTiming = getNavigationTimingSnapshot();
    if (navTiming) {
      markLoad('navigation_timing', navTiming);
    }
  })
  .catch((err) => {
    debugLog.error('bootstrap', 'Angular bootstrap failed', debugLog.describeHttpError(err));
    console.error(err);
  });
